import { render, staticRenderFns } from "./admin-list-assign-contact-form.vue?vue&type=template&id=50fe8f14"
import script from "./admin-list-assign-contact-form.vue?vue&type=script&lang=js"
export * from "./admin-list-assign-contact-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports